export default "__VITE_ASSET__BQ8f5f0S__"